import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useAuth } from '../../contexts/auth';
import api from '../../services/api';
import ProfileForm, { ProfileFields } from './ProfileForm';
import SignaturePad from '../../components/Signature/SignaturePad';

export default function Profile() {
  const {
    user: { organization },
  } = useAuth();

  const [activeTab, setActiveTab] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [formFields, setFormFields] = useState<ProfileFields>(
    null as unknown as ProfileFields
  );
  const [formErrors, setFormErrors] = useState({});
  const [signature, setSignature] = useState('');

  async function getUser() {
    if (organization) {
      const { data } = await api.get(
        `organizations/${organization.id}/profile`
      );

      setFormFields({
        name: data.name,
        email: data.email,
      });
      setSignature(data.signature);
      setIsLoading(false);
    }
  }

  const onSubmit = async (data: ProfileFields) => {
    try {
      const { passwordConfirm, ...profile } = data;

      await api.put(`organizations/${organization.id}/profile`, profile);

      toast.success('Perfil alterado com sucesso');
    } catch (e: any) {
      if (e.response.data.errors) {
        setFormErrors(e.response.data.errors);
      }
    }
  };

  const handleSignature = async (dataUrl: string | undefined) => {
    try {
      const { data } = await api.post(
        `organizations/${organization.id}/profile/sign`,
        {
          signature: dataUrl,
        }
      );
      setSignature(data.signature);
      toast.success('Assinatura salva');
    } catch (e: any) {
      console.log(e);
    }
  };

  useEffect(() => {
    getUser();
  }, [organization]);

  return (
    <>
      <ul className='nav nav-tabs mb-3'>
        <li className='nav-item'>
          <button
            type='button'
            className={`nav-link ${activeTab === 0 ? 'active' : ''}`}
            aria-current='page'
            onClick={() => setActiveTab(0)}
          >
            Dados
          </button>
        </li>
        <li className='nav-item '>
          <button
            type='button'
            className={`nav-link ${activeTab === 1 ? 'active' : ''}`}
            onClick={() => setActiveTab(1)}
          >
            Assinatura
          </button>
        </li>
      </ul>
      {activeTab === 0 && (
        <ProfileForm
          isLoading={isLoading}
          title='Editar'
          formFields={formFields}
          formErrors={formErrors}
          onSubmit={onSubmit}
        />
      )}
      {activeTab === 1 && (
        <div className='mb-3'>
          <SignaturePad
            handleSignature={handleSignature}
            signature={signature}
            height={600}
          />
        </div>
      )}
    </>
  );
}
